import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { LinearProgress } from "@mui/material";

const CustomLinearProgressBar = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== "bg" && prop !== "isCritical",
})(({ bg, isCritical }) => ({
  height: 8,
  borderRadius: 5,
  backgroundColor: isCritical ? "error.red300" : bg ?? "background.blue400",
  "& .MuiLinearProgress-bar": {
    borderRadius: 5,
    backgroundColor: isCritical ? undefined : "primary.main",
  },
}));

const CustomLinearProgress = ({ value, bg, isCritical = false }) => {
  const [internalValue, setInternalValue] = useState(0);

  useEffect(() => {
    // force start from 0
    setInternalValue(0);

    // next frame → animate to the real value
    const id = requestAnimationFrame(() => {
      setInternalValue(value);
    });

    return () => cancelAnimationFrame(id);
  }, [value]);

  return (
    <CustomLinearProgressBar
      variant="determinate"
      value={internalValue}
      color={isCritical ? "error" : "primary"}
      bg={bg}
      isCritical={isCritical}
    />
  );
};

export default CustomLinearProgress;